/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Expiration_6monthsInputs */

const he_notifications_expiration_6months = /** @type {(inputs: Notifications_Expiration_6monthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 חודשים`)
};

const en_notifications_expiration_6months = /** @type {(inputs: Notifications_Expiration_6monthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 Months`)
};

/**
* | output |
* | --- |
* | "6 Months" |
*
* @param {Notifications_Expiration_6monthsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_expiration_6months = /** @type {((inputs?: Notifications_Expiration_6monthsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Expiration_6monthsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_expiration_6months(inputs)
	return en_notifications_expiration_6months(inputs)
});